export const ErrorsExceptions = {
    TASK_NAME_DUPLICATE: 'com.actimind.actitime.task.TaskExistsException',
    PROJECT_REMOVED: 'com.actimind.actitime.project.NoSuchProjectException',
    PROJECT_ARCHIVED: 'com.actimind.actitime.project.ProjectArchivedException',
    CUSTOMER_REMOVED: 'com.actimind.actitime.customer.NoSuchCustomerException',
    BILLING_TYPE_REMOVED: 'com.actimind.actitime.administration.NoSuchATTypeException',
}

export const Methods = {
    STATUS: "EditTaskService.updateTaskStatus",
    WORKFLOW_STATUS: 'EditTaskService.updateTaskWorkflowStatus',
    ESTIMATED_TIME: "EditTaskService.updateTaskEstimatedTime",
    DEADLINE: "EditTaskService.updateTaskDeadline",
    BILLING_TYPE: "EditTaskService.updateBillingType",
    NAME: "EditTaskService.updateTaskName",
    DESCRIPTION: "EditTaskService.updateTaskDescription",
    TIME_COMMENTS: "EditTaskService.getTimeComments",
    SAVE_SETTINGS: "EditTaskService.saveTimeCommentSettings",
    MOVE_TASK: "EditTaskService.moveTask",
    COPY_TASK: "EditTaskService.copyTask",
    DELETE_TASK: "EditTaskService.deleteTaskFromPanel",
    GET_LAST_AUDIT_INFO: "EditTaskService.getLastAuditActionsInfo",
    GET_AUDIT_RECORDS: "EditTaskService.getAuditActions",
    LOAD_EDIT_TASK_PANEL: "EditTaskService.loadEditTaskPanel",
    LOAD_CREATE_TASK_PANEL: "EditTaskService.loadCreateTaskPanel",
    CREATE_TASK: "EditTaskService.createTask"
};

export const ResultCodes = window.__GENERATED_CONSTANTS__.EditTaskServiceResultCodes;

export const REPORTED_TIME_COMMENTS_RECORDS_LIMIT = 20

export const ReportedTimeSortConstants = {
    BY_DATE: "date",
    BY_USER: "user",
    ASC: "Asc",
    DESC: "Desc"
}

export const ValidationErrors = {
    TASK_NAME_DUPLICATE: "taskNameDuplicate",
    TASK_NAME_EMPTY: "taskNameIsEmpty",
}

export const TasksTabs = {
    DETAILS_TAB: 'details',
    REPORTED_TAB: 'reportedTime',
    ASSIGNED_USERS_TAB: 'assignedUsers',
    MANAGERS_TAB: 'managers'
}

export const TaskDialogs = {
    MOVE_DIALOG: 'move',
    COPY_DIALOG: 'copy',
    DELETE_DIALOG: 'delete'
}



// WEBPACK FOOTER //
// ./web/js/panels/task/constants.js